export const envConfig = JSON.parse(localStorage.getItem("envConfig"))

console.log(envConfig)

export default envConfig
